// extracted by mini-css-extract-plugin
export default {"groupContainer":"Groups_groupContainer__mCznR","TopOfTable":"Groups_TopOfTable__6VSNd","leftTop":"Groups_leftTop__lKnKR","InfoCountTable":"Groups_InfoCountTable__Dk5Vk"};